module.exports = __webpack_public_path__ + "img/mastercard@2x.b723b542.png";